import React, { useState } from 'react';

import { GetStageSheet_getStageSheet_details as StageSheet } from '../../../../types/schemaTypes';
import './StageSheet.scss';
import { blockInvalidChar } from '../../../_common/blockInvalidChar';
import { NumericFormat as NumberFormat } from 'react-number-format';

interface StageToRevertProps {
    stageSheetBoxId: number;
    loadId: number;
    weight: number;
    weightRemaining: number;
}

interface StageSheetRORevertModeProps {
    stageSheet: StageSheet;
    stagesToRevert: StageToRevertProps[];
    setStagesToRevert: React.Dispatch<React.SetStateAction<StageToRevertProps[]>>;
    weightInvalidErrorList: number[];
    setWeightInvalidErrorList: React.Dispatch<React.SetStateAction<number[]>>;
    weightRemainingInvalidErrorList: number[];
    setWeightRemainingInvalidErrorList: React.Dispatch<React.SetStateAction<number[]>>;
    weightZeroErrorList: number[];
    setWeightZeroErrorList: React.Dispatch<React.SetStateAction<number[]>>;
    weightRemainingErrorList: number[];
    setWeightRemainingErrorList: React.Dispatch<React.SetStateAction<number[]>>;
    isRevertStageSheetEnabled: boolean;
}

const StageSheetBellyDumpRORevertMode = ({
    stageSheet,
    stagesToRevert,
    setStagesToRevert,
    weightInvalidErrorList,
    setWeightInvalidErrorList,
    weightRemainingInvalidErrorList,
    setWeightRemainingInvalidErrorList,
    weightZeroErrorList,
    setWeightZeroErrorList,
    weightRemainingErrorList,
    setWeightRemainingErrorList,
    isRevertStageSheetEnabled,
}: StageSheetRORevertModeProps): React.ReactElement => {
    const [weight, setWeight] = useState(stageSheet.boxWeight);
    const [weightRemaining, setWeightRemaining] = useState(stageSheet.boxWeightRemaining);

    const errorMessages = {
        invalidError: 'Enter a valid number',
        weightZeroError: 'Should not be 0',
        weightRemainingError: 'Should not be more than ',
    };

    const handleOnChangeWeight = weight => {
        setWeight(weight);

        if (weightInvalidErrorList.includes(stageSheet.stageSheetBoxId ?? 0))
            weightInvalidErrorList.splice(weightInvalidErrorList.indexOf(stageSheet.stageSheetBoxId ?? 0), 1);
        if (weightZeroErrorList.includes(stageSheet.stageSheetBoxId ?? 0))
            weightZeroErrorList.splice(weightZeroErrorList.indexOf(stageSheet.stageSheetBoxId ?? 0), 1);

        const tempStagesToRevert = stagesToRevert;
        let exists = false;
        tempStagesToRevert.map(stageToRevert => {
            if (stageToRevert.stageSheetBoxId === stageSheet.stageSheetBoxId) {
                exists = true;
                stageToRevert.weight = weight;
            }
        });
        if (!exists) {
            const stageToRevert: StageToRevertProps = {
                loadId: stageSheet.loadId ?? 0,
                stageSheetBoxId: stageSheet.stageSheetBoxId ?? 0,
                weight: weight,
                weightRemaining: weightRemaining ?? 0,
            };
            tempStagesToRevert.push(stageToRevert);
        }
        setStagesToRevert(tempStagesToRevert);
    };

    const handleOnChangeWeightRemaining = weightRemaining => {
        setWeightRemaining(weightRemaining);

        if (weightRemainingInvalidErrorList.includes(stageSheet.stageSheetBoxId ?? 0))
            weightRemainingInvalidErrorList.splice(
                weightRemainingInvalidErrorList.indexOf(stageSheet.stageSheetBoxId ?? 0),
                1,
            );
        if (weightRemainingErrorList.includes(stageSheet.stageSheetBoxId ?? 0))
            weightRemainingErrorList.splice(weightRemainingErrorList.indexOf(stageSheet.stageSheetBoxId ?? 0), 1);

        const tempStagesToRevert = stagesToRevert;
        let exists = false;
        tempStagesToRevert.map(stageToRevert => {
            if (stageToRevert.stageSheetBoxId === stageSheet.stageSheetBoxId) {
                exists = true;
                stageToRevert.weightRemaining = weightRemaining;
            }
        });
        if (!exists) {
            const stageToRevert: StageToRevertProps = {
                loadId: stageSheet.loadId ?? 0,
                stageSheetBoxId: stageSheet.stageSheetBoxId ?? 0,
                weight: weight ?? 0,
                weightRemaining: weightRemaining,
            };
            tempStagesToRevert.push(stageToRevert);
        }
        setStagesToRevert(tempStagesToRevert);
    };

    return (
        <>
            {stageSheet.stageSheetBellyDump?.map((load, loadIndex) => (
                <>
                    <tr className="StageSheet-Container">
                        {loadIndex === 0 && (
                            <>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.station === '0' ? '' : stageSheet.station}</td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <div className="StageSheet-GreenDot-Container">
                                        {stageSheet.boxDesc}
                                        {stageSheet.isPartial === 'Yes' && <div className="StageSheet-GreenDot" />}
                                    </div>
                                </td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <input
                                        type="number"
                                        className="StageSheet-Grid-Input"
                                        value={weight ?? 0}
                                        onKeyDown={blockInvalidChar}
                                        onChange={event => handleOnChangeWeight(parseInt(event.target.value))}
                                    />
                                    {weightInvalidErrorList.map(index => {
                                        if (index === stageSheet.stageSheetBoxId)
                                            return <div key={index} className="StageSheet-Error">{errorMessages.invalidError}</div>;
                                    })}
                                    {weightZeroErrorList.map(index => {
                                        if (index === stageSheet.stageSheetBoxId)
                                            return <div key={index} className="StageSheet-Error">{errorMessages.weightZeroError}</div>;
                                    })}
                                </td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                    <input
                                        type="number"
                                        className="StageSheet-Grid-Input"
                                        value={weightRemaining ?? 0}
                                        onKeyDown={blockInvalidChar}
                                        onChange={event => handleOnChangeWeightRemaining(parseInt(event.target.value))}
                                    />
                                    {weightRemainingInvalidErrorList.map(index => {
                                        if (index === stageSheet.stageSheetBoxId)
                                            return <div key={index} className="StageSheet-Error">{errorMessages.invalidError}</div>;
                                    })}
                                    {weightRemainingErrorList.map(index => {
                                        if (index === stageSheet.stageSheetBoxId)
                                            return (
                                                <div key={index} className="StageSheet-Error">{errorMessages.weightRemainingError + weight}</div>
                                            );
                                    })}
                                </td>
                                
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.proppant}</td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.location}</td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.isOOS ? 'Yes' : 'No'}</td>
                                {isRevertStageSheetEnabled && (
                                    <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                        {/* <div className="StageSheet-Buttons-Container">
                                            <button className="StageSheet-Buttons StageSheet-Button-Disabled">Edit Delivered Wt</button>
                                        </div> */}
                                    </td>
                                )}
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.sandPo}</td>
                                <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.lofaOrigin}</td>
                            </>
                        )}
                    <td>{load?.loadId}</td>
                    <td>{load?.sandTicket}</td>
                    <td>{load?.sandTicketWeight}</td>
                    <td>{load?.sandTicketWeightRemaining}</td>
                    {/* {isRevertStageSheetEnabled && (
                                    <td>
                                        <div className="StageSheet-Buttons-Container">
                                            <button className="StageSheet-Buttons StageSheet-Button-Disabled">Edit Delivered Wt</button>
                                        </div>
                                    </td>
                                )} */}
                    

            </tr>
            </>
            ))}
            {/* For Tab */}
            <div className="StageSheet-Tab-Item-Container StageSheet-Edit-Item-Container-For-Tab">
                <div className="StageSheet-Tab-Item">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Station #:</span>
                        <span className="StageSheet-Value">{stageSheet.station === '0' ? '' : stageSheet.station}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">PO #:</span>
                        <span className="StageSheet-Value">{stageSheet.sandPo}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Box Wt:</span>
                        <span className="StageSheet-Value">
                            <input
                                type="number"
                                className="StageSheet-Grid-Input"
                                value={weight ?? 0}
                                onKeyDown={blockInvalidChar}
                                onChange={event => handleOnChangeWeight(parseInt(event.target.value))}
                            />
                            {weightInvalidErrorList.map(index => {
                                if (index === stageSheet.stageSheetBoxId)
                                    return <div key={index} className="StageSheet-Error">{errorMessages.invalidError}</div>;
                            })}
                            {weightZeroErrorList.map(index => {
                                if (index === stageSheet.stageSheetBoxId)
                                    return <div key={index} className="StageSheet-Error">{errorMessages.weightZeroError}</div>;
                            })}
                        </span>
                    </div>
                    {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                        <div key={idx} className="StageSheet-KeyValues">
                            <span className="StageSheet-Key">Ticket {idx + 1} :</span>
                            <span className="StageSheet-Value">
                            {load?.sandTicket || 0}
                            </span>
                        </div>
                    ))}
                </div>

                <div className="StageSheet-Tab-Item StageSheet-Tab-Item-Lg">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Origin:</span>
                        <span className="StageSheet-Value">{stageSheet.lofaOrigin}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Pad Location:</span>
                        <span className="StageSheet-Value">{stageSheet.location}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Box Wt Remaining:</span>
                        <span className="StageSheet-Value">
                            <input
                                type="number"
                                className="StageSheet-Grid-Input"
                                value={weightRemaining ?? 0}
                                onKeyDown={blockInvalidChar}
                                onChange={event => handleOnChangeWeightRemaining(parseInt(event.target.value))}
                            />
                            {weightRemainingInvalidErrorList.map(index => {
                                if (index === stageSheet.stageSheetBoxId)
                                    return <div key={index} className="StageSheet-Error">{errorMessages.invalidError}</div>;
                            })}
                            {weightRemainingErrorList.map(index => {
                                if (index === stageSheet.stageSheetBoxId)
                                    return (
                                        <div key={index} className="StageSheet-Error">
                                            {errorMessages.weightRemainingError + weight}
                                        </div>
                                    );
                            })}
                        </span>
                    </div>
                    {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                        <div key={idx} className="StageSheet-KeyValues">
                            <span className="StageSheet-Key">St Wt/ St Wt Remaining:</span>
                            <span className="StageSheet-Value">
                                <NumberFormat
                                    value={load?.sandTicketWeight || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                />
                                /
                                <NumberFormat
                                    value={load?.sandTicketWeightRemaining || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                />
                            </span>
                        </div>
                    ))}
                </div>

                <div className="StageSheet-Tab-Item">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Box:</span>
                        <span className="StageSheet-Value">
                            <div className="StageSheet-GreenDot-Container">
                                {stageSheet.boxDesc}
                                {stageSheet.isPartial === 'Yes' && <div className="StageSheet-GreenDot" />}
                            </div>
                        </span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Type:</span>
                        <span className="StageSheet-Value">{stageSheet.proppant}</span>
                    </div>
                    <br />
                    {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                        <div key={idx} className="StageSheet-KeyValues">
                            <span className="StageSheet-Key">Load {idx + 1} #:</span>
                            <span className="StageSheet-Value">
                            {load?.loadId || 0}
                            </span>
                        </div>
                    ))}
                </div>

                {/* <div className="StageSheet-Tab-Button-Item">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">OOS:</span>
                        <span className="StageSheet-Value">{stageSheet.isOOS ? 'Yes' : 'No'}</span>
                    </div>
                    {isRevertStageSheetEnabled && (
                        <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled StageSheet-LoadWeight-Buttons-For-Tab">
                            Edit Delivered Wt
                        </button>
                    )}
                </div> */}
            </div>
            
        </>
    );
};

export default StageSheetBellyDumpRORevertMode;
